import { TXGUISection } from "../../interfaces/gui/fields.interfaces";

export const X_FOOTER_GUI_FIELDS: TXGUISection = {
  Général: [
    {
      type: "color",
      name: "bgColor",
      label: "Couleur d'arriere plan",
    },
    {
      type: "sides",
      name: "margin",
      label: "Espace Externe (Margin)",
      units: ["px", "em", "%", "auto"],
    },
    {
      type: "sides",
      name: "padding",
      label: "Espace Interne (Padding)",
      units: ["px", "em", "%", "auto"],
    },
  ],
};
